import { PI } from '../constants-types/PI.model';

export class ConsoleLogger {
    /** Wrapper for console.log that won't output logs to prod */
    static log(...args: any[]): void {
        if (!PI.appSettings.enableProdMode) {
            console.log(...args);
        }
    }
}
